<!--
// app/components/layout/header/IconBurgerShowDropbar.vue
-->
<script setup lang="ts">
type Props = {
  showNavMobile: boolean;
};

withDefaults(defineProps<Props>(), {
  showNavMobile: false,
});

defineEmits(["showNavMobile"]);
</script>

<template>
  <button
    title="open menu"
    class="text-black ml-auto rtl:mr-auto rtl:ml-0 lg:hidden"
    @click="$emit('showNavMobile')"
  >
    <svg
      v-if="!showNavMobile"
      class="w-5 h-5"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 17 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M1 1h15M1 7h15M1 13h15"
      />
    </svg>
    <svg
      v-else
      class="w-5 h-5"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
      />
    </svg>
  </button>
</template>

<style scoped></style>
